<div class="trade-client-detail-view">
    <div class="">
        <tc-setup-grid
            #dispatchViewGrid
            [gridHeader]="'Document Queue Details'"
            [readOnly]="true"
            [noSelection]="true"
            [colDefConfig]="colDefConfig"
            [setupGridComp]="this"
            [actions]="gridActions"
            [dataSource]="this">
        </tc-setup-grid>
    </div>
</div>


<!--status column view-->
<ng-template #statusCell let-row>
    <ng-container *ngIf="row?.dispatchStatus">
        <div class="tc-w-100 text-center">
            <!--            <div-->
            <!--                    class="tc-status-badge tc-status-badge&#45;&#45;success" style="width: fit-content;-->
            <!--    left: 0;-->
            <!--    padding: 10px;-->
            <!--    border-radius: 10px;"-->
            <!--                    [ngClass]="{'tc-status-badge&#45;&#45;warning': row.dispatchStatus === 'PENDING',-->
            <!--                                            'tc-status-badge&#45;&#45;success': row.dispatchStatus === 'SUCCESS',-->
            <!--                                            'tc-status-badge&#45;&#45;danger': row.dispatchStatus === 'FAILED'-->
            <!--                                            }">-->
            <div>
                <span class=""> {{row.dispatchStatus}}</span>
            </div>
        </div>
    </ng-container>
</ng-template>
